import { BREW_DEMO_BOOKING_URL } from '@/lib/site/booking'
import type { HomeTranslator } from '../home-messages'

/**
 * Links and art for the founders widget (Paper "Founders card — v2
 * (illustration)"). The copy is `marketingHome.founders`.
 */
export const FOUNDERS_WIDGET = {
  /** The Brew demo booking page on Cal.com. */
  href: BREW_DEMO_BOOKING_URL,
  /** Resting drawing: handset on the phone. */
  imageRest: '/landing/home/founders/founders-rest.png',
  /** Hover drawing: Thomas lifts the handset to his ear. */
  imageUp: '/landing/home/founders/founders-up.png',
  /** Real photos for the collapsed launcher; one is picked per page view. */
  photos: {
    philip: '/people/philip_sorensen.png',
    thomas: '/people/thomas_park.jpeg',
  },
} as const

/** The widget's strings: it is a client island, so they arrive as props. */
export type FoundersWidgetCopy = {
  title: string
  body: string
  cta: string
  /** The card link's accessible name: its title and its call to action. */
  cardLabel: string
  /** The speech bubble beside the collapsed launcher, and its name. */
  bubble: string
  /** The open launcher's accessible name. */
  hideLabel: string
}

export function buildFoundersWidgetCopy(t: HomeTranslator): FoundersWidgetCopy {
  return {
    title: t('founders.title'),
    body: t('founders.body'),
    cta: t('founders.cta'),
    cardLabel: t('founders.cardLabel'),
    bubble: t('founders.bubble'),
    hideLabel: t('founders.hideLabel'),
  }
}
